import * as firebase from 'firebase'
import * as moment from 'moment'

// Added the parser so we can correctly add references into the firebase database, eg: instrucors: {"instructorId": true}
export const referenceKeyParser = i => {
  return { [i]: true }
}

// Added the parser so we can correctly display the parsed values from above
export const referenceKeyFormatter = i => {
  return !i ? '' : Object.keys(i)[0]
}

export const dateFormatter = v => {
  // v is a string of "YYYY-MM-DD" format
  // console.log('date formatter', v)
  return v ? new Date(v) : undefined
}

export const dateParser = v => {
  // v is no longer a `Date` object https://github.com/marmelab/admin-on-rest/pull/1088
  // console.log('date parser', v)
  return v ? new Date(v) : undefined
}

export const getCurrentUserId = () => {
  return firebase.auth().currentUser ? firebase.auth().currentUser.uid : ''
}

export const dateDisplay = date => (date ? date.format('DD/MM/YYYY') : '')

export const dateDisplayFromString = dateString =>
  dateString ? dateDisplay(moment(dateParser(dateString))) : ''

export const hourDisplayFromString = dateString =>
  dateString ? moment(dateParser(dateString)).format('HH:mm') : ''

export const getStudentName = student =>
  student.firstName && student.lastName
    ? `${student.lastName} ${student.firstName}`
    : ''

export const capitalize = str =>
  str.toLowerCase().replace(/\b\w/g, l => l.toUpperCase())

export const isStudentPresent = (course, studentId) =>
  course &&
  course.attendance &&
  course.attendance.hasOwnProperty(studentId) &&
  course.attendance[studentId]



// WEBPACK FOOTER //
// ./src/helpers.js